import React, { useEffect, useState,useCallback, useMemo } from 'react';
import style from '../../Styles/Order/OrderSummary.module.css'
import { ApiCallerConnection } from '../../Api/ApiCallerConnection';
import Enum from '../../Common/Enum/Enum';

const OrderSummary = ({ idOrderParam,phoneNumber }) => {
  
    const [formData, setFormData] = useState({        
        status: '',
        firstName: '',
        lastName: '',
        adresse: '',
        orderComments: '',
        totalprice : '' ,
        orderDetail : []  
    });

    const [hasCalledApi, setHasCalledApi] = useState(false);

    const [apiState, setApiState] = useState({
        loading: true,
        apiData : null,
        error: null
      });
      
    const idOrderObject = useMemo(() => ({
        idOrder: idOrderParam,
        phoneNumber : phoneNumber
    }), [idOrderParam,phoneNumber]);

    const updateApiState = useCallback((updates) => {
        setApiState(prev => ({ ...prev, ...updates }));
    }, []);
 
    useEffect(() => {
        if (apiState.apiData) {
            setFormData(prev => ({
            ...prev,
            status: apiState.apiData.status || '',
            firstName: apiState.apiData.firstName || '',
            lastName: apiState.apiData.lastName || '',
            adresse: apiState.apiData.adresse || '',
            orderComments: apiState.apiData.orderComments || '',
            totalprice : apiState.apiData.totalprice || '',
            orderDetail : apiState.apiData.orderDetail || []             
          }));
          setApiState(prev => ({ ...prev, loading: false }));
        }
    }, [apiState.apiData]); 

    const OrderDetailItem = ({ item }) => (
        <div className="order-detail-item" style={{ 
          display: 'flex', 
          gap: '20px', 
          marginBottom: '15px',
          padding: '10px',
          borderBottom: '1px solid #eee'
        }}>
          <div style={{ flex: '0 0 100px' }}>
            <img src={item.imagePath} alt={item.productDescription} style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
          </div>
          <div style={{ flex: 1 }}>
            <div><strong>{item.productDescription}</strong></div>
            <div>Cantidad: {item.quantity}</div>
            <div>Subtotal: Q.{item.linePrice}</div>
            <div style={{ fontSize: '0.9em', color: '#667' }}>{item.comments}</div>
          </div>
        </div>
      );

      const InfoLabel = ({ label, value, icon }) => (
        <div className={style.infoLabel} translate="no">
          <span style={{
            fontSize: '0.75rem',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: '#6c757d',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            {icon && <span style={{ fontSize: '0.9rem' }}>{icon}</span>}
            {label}
          </span>
          <span style={{
            fontSize: '1rem',
            fontWeight: '500',
            color: '#212529',
            wordBreak: 'break-word'
          }}>
            {value || '—'}
          </span>
        </div>
      );

    const orderSummaryForm = useMemo(() => {
        return (
            <div className={style.mainContainer}>
                <div className={style.formContainer}>
                    <div>      
                        <InfoLabel
                          label="Nombre:"
                          value={`${formData.firstName} ${formData.lastName}`.trim()}
                          icon="👤"/>                                
                    </div>            
                    <div>
                    <InfoLabel
                          label="Dirección:"
                          value={`${formData.adresse}`.trim()}
                          icon="💬"/>
                    </div>
                    <div>
                    <InfoLabel
                        label="Estado:"
                        value={formData.status === Enum.OPEN ? "Pedida" : formData.status === Enum.INPROGRESS ? "Preparando" : formData.status === Enum.ONROUTE ? "En ruta" : "Entregada" }
                        icon="📋"/>                       
                    </div>
                    <div>
                    <InfoLabel
                        label="Forma de pago:"
                        value={formData.orderComments?.replace("Forma de pago :", '')}
                        icon="💬"/>                       
                    </div>
                    <div>
                    <InfoLabel
                        label="Total:"
                        value={formData.totalprice ? `Q. ${formData.totalprice}` : ''}
                        icon="💰"/> 
                    </div>                                    
                </div>
              
                <div className={style.orderDetailContainer}>
                    {formData.orderDetail && formData.orderDetail.length > 0 && (
                      <div>
                        <h5>Detalle de la orden:</h5>
                        {formData.orderDetail.map((item, index) =>  (
                          <OrderDetailItem key={index} item={item} />
                        ))}
                      </div>
                    )}
                </div>                                 
                               
            </div>
        );
    }, [formData]); 

    return (
        <div className={style.summaryOrderMainContainer}>
            <ApiCallerConnection method={process.env.REACT_APP_API_POST} url={process.env.REACT_APP_API_POST_GETORDERBYID} useAuth={false} data={idOrderObject}>
                {(response) => {
                    if (response.dataResponse && !apiState.apiData && !hasCalledApi) {
                        setHasCalledApi(true);  
                        setTimeout(() => updateApiState({ apiData: response.dataResponse }), 0);  
                    }
                    if (response.error && !apiState.error) {
                        setTimeout(() => updateApiState({ error: response.error }), 0);
                    }
                    return orderSummaryForm;
                }}
            </ApiCallerConnection>
        </div>
    )
}

export default OrderSummary